import ViolationsTabDetailsMitigating from './ViolationsTabDetailsMitigating';

export default ViolationsTabDetailsMitigating;
